import createClient, { Client } from 'openapi-fetch'

import getRestApiUrl from '@kidzonet/get-rest-api-url'
import type { paths } from '@kidzonet/ts-api-generator/clients/dashboard'
import { AuthMiddleware, ErrorHandlingMiddleware } from '@kidzonet/ts-api-localstorage-middleware'

declare global {
    // eslint-disable-next-line vars-on-top
    var DashboardApiClient: Client<paths>
}

export default () => {
    globalThis.DashboardApiClient = createClient<paths>({ baseUrl: getRestApiUrl() })
    globalThis.DashboardApiClient.use(AuthMiddleware)
    globalThis.DashboardApiClient.use(ErrorHandlingMiddleware)
}
